import { AUTH_URL } from "@shared/constants";
import { AuthProvider } from "@shared/types";

import { authGet } from "./auth";

export const fetchAuthConfig = (
  authProviderName: string
): Promise<AuthProvider> => {
  return authGet<AuthProvider>(`${AUTH_URL}/config/${authProviderName}`);
};
